import { message, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function batchDelete({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.confirm({
      content: 'Do you want to delete these records?',
      okText: 'Delete',
      okType: 'danger',
      callback: function () {
        httpClient
          .post('Business/ApprovalExemptionPartialCompliance/BatchDelete', sectionComponent.child.current?.state.selectedRowKeys)
          .then(({ data }) => {
            if (data.result) {
              sectionComponent.child.current?.setState({ selectedRowKeys: [] });
              setTimeout(() => {
                sectionComponent.child.current?.getSectionDataByDefault();
              }, config.setTimeoutMilliSecond);
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, pageComponent);
          });
      }
    });
  } else {
    message.warning('You must select at least one exemption partial compliance.');
  }
}

export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  openAddFromTemplate({ component: pageComponent });
}

// 在 Approval Detail 内快速编辑 Job 的 Exemption Consent 资料。
export function editExemptionConsent({ pageComponent } = {}) {
  pageComponent.setState({ exemptionConsentEditShow: true });
}

export function openAddFromTemplate({ component } = {}) {
  component.setState({ approvalExemptionPartialComplianceAddFromTemplateShow: true });
  setTimeout(() => {
    component.approvalExemptionPartialComplianceAddFromTemplate.current?.formRef.current?.resetFields();
    component.approvalExemptionPartialComplianceAddFromTemplate.current?.setState({ defaultSelectedRowKeys: [], selectedRowKeys: [] });
    setTimeout(() => {
      component.approvalExemptionPartialComplianceAddFromTemplate.current?.getExemptionPartialComplianceTemplate();
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}
